import * as React from 'react';
import {
    Create, useRedirect,
} from 'react-admin';

import SuppliersEditCreate from "./SuppliersEditCreate";
import PostEditActions from "../../_common/PostEditActions";

export const SuppliersCreate = props => {

    const {location} = props;
    const {search} = location;

    //const redirect = useRedirect()

    let idSource = '';
    //let bookingId = '';
    if(search){
        let url = new URL('https://test/' + search);
        idSource = url.searchParams.get('idSource')
    }

    const redirect = useRedirect()

    return (
        <Create
            {...props}
            title={''}
            onSuccess={() => idSource ? props.history.goBack() : redirect('list', props.basePath)}
            //onSuccess={() => props.history.goBack()}
            //onSuccess={onSuccessData}
            actions={<PostEditActions/>}
            //fullWidth
            //   undoable={false} //Подтверждение удаления
            //   actions={<PostEditActions/>}
        >
            <SuppliersEditCreate idSource={idSource}/>
        </Create>
    )
};